import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private snackBar = inject(MatSnackBar);
  private translateService = inject(TranslateService);

  showSnackBar(data: {
    messageKey: string;
    messageKeyParams?: object;
    actionKey?: string;
    actionKeyParams?: string;
    duration?: number;
  }) {
    return combineLatest([
      this.translateService.get(data.messageKey, data.messageKeyParams),
      data.actionKey
        ? this.translateService.get(data.actionKey, data.actionKeyParams)
        : of([]),
    ]).pipe(
      switchMap(([message, action]) =>
        this.snackBar
          .open(message, action ?? undefined, {
            duration: data.duration ?? 3000,
            panelClass: 'snackbar',
          })
          .onAction(),
      ),
    );
  }
}
